// extracted by mini-css-extract-plugin
export var hidden = "_72-1";
export var visible = "_72-0";